
import Vue from 'vue';
import { Mixins } from '@vedicium/metronic-vue';
import { BModal } from 'bootstrap-vue';

import {
  SEARCH_LIGHT_SOURCE_MODAL_EVENT_CLOSE,
  SEARCH_LIGHT_SOURCE_MODAL_EVENT_OPEN,
} from '../constants';
import { SearchLightSourceModalOptions } from '../interfaces';
import PartsLightSourcesVueSelect from './light-sources.vue-select.vue';
import { LightSourcePartEntity } from '../../../../../services/parts';

export default Vue.extend({
  mixins: [Mixins.Modal],
  name: 'SearchLightSourceModal',
  components: {
    PartsLightSourcesVueSelect,
  },
  data() {
    return {
      entity: undefined as LightSourcePartEntity | undefined,

      options: undefined as SearchLightSourceModalOptions | undefined,
    };
  },

  mounted() {
    this.$eventhub.on(SEARCH_LIGHT_SOURCE_MODAL_EVENT_OPEN, this.open);
    this.$eventhub.on(SEARCH_LIGHT_SOURCE_MODAL_EVENT_CLOSE, this.close);
  },
  beforeDestroy() {
    this.$eventhub.off(SEARCH_LIGHT_SOURCE_MODAL_EVENT_OPEN, this.open);
    this.$eventhub.off(SEARCH_LIGHT_SOURCE_MODAL_EVENT_CLOSE, this.close);
  },

  methods: {
    async onSubmit(): Promise<void> {
      if (typeof this.options?.onSubmit === 'function') {
        await this.options.onSubmit(this.entity);
      }

      this.close();
    },

    open(options?: SearchLightSourceModalOptions): void {
      this.$set(this, 'options', options || undefined);
      this.$set(this, 'entity', undefined);

      (this.$refs.modal as BModal).show();
    },
    close(): void {
      (this.$refs.modal as BModal).hide();
    },

    onShown(): void {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this.$refs['input:light-source'] as any).focus();
    },
  },
});
